export function removeFromDom(selectors: string): void {
  document.querySelectorAll(selectors).forEach((el: Element) => {
    el.parentElement?.removeChild(el);
  });
}
